import React from 'react'
import clsx from 'clsx'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const ProgramPhaseTable = props => {
  const { data, page, onPageChange, pageSize = 10 } = props

  return (
    <Card className={clsx('promo-table')}>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Phase</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Program ID</TableCell>
                  <TableCell>Program Name</TableCell>
                  <TableCell>Weekly Goal</TableCell>
                  <TableCell>Progression Guideline</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.rows &&
                  data.rows.map(phase => (
                    <TableRow key={phase.id} hover>
                      <TableCell>{phase.id}</TableCell>
                      <TableCell>{phase.phase}</TableCell>
                      <TableCell>{phase.title}</TableCell>
                      <TableCell>{phase.description}</TableCell>
                      <TableCell>{phase.program_id}</TableCell>
                      <TableCell>{phase.program?.name || ''}</TableCell>
                      <TableCell>{phase.weekly_goal}</TableCell>
                      <TableCell>{phase.progression_guideline}</TableCell>
                      <TableCell>{phase.active ? 'True' : 'False'}</TableCell>
                      <TableCell>
                        <EditBtn
                          module="programPhase"
                          history={props.history}
                          path={`/program-phases/edit/${phase.id}`}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={pageSize}
          rowsPerPageOptions={[pageSize]}
        />
      </CardActions>
    </Card>
  )
}

export default ProgramPhaseTable
